import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useWindowDimensions from '../../hooks/windowResize';
import WelcomeSection from './welcome-section';
import InquiriesSection from './inquiries-section';
import FeaturesSection from './features-section';
import ServicesInfoSection from './services-info-section';
import VideoGuidesSection from './video-guides-section';
import PersonalSupportSection from './personal-support-section';

import './HomePage.scss';
import SocialSection from './social-section';

const HomePage = ({ user }) => {
  const { t } = useTranslation();
  const { screenWidth } = useWindowDimensions();

  useEffect(() => {
    // Initialize Lucide icons
    if (window.lucide) {
      window.lucide.createIcons();
    }
  }, []);

  return (
    <div className="home-page-container">
      <div className="home-page-title-container">
        <div className="home-page-title">
          {/*<Text text={t('home-page-title')}/>*/}
        </div>
      </div>

      {/* New sections from HTML */}
      <div className="home-page-content-container">
        <WelcomeSection />
        <FeaturesSection />
        <InquiriesSection />
        <ServicesInfoSection />
        <VideoGuidesSection />
        <PersonalSupportSection />
         <SocialSection />
      </div>

      {/* Existing sections */}
      {/*<AdditionalLinks/>*/}
      {/*<YeulSachir/>*/}
      {/*<ContactUs /> */}
    </div>
  );
};

export default HomePage;
